//
// Copyright 2026 DXOS.org
//

import { Event } from '@dxos/async';

import * as WorkerProtocol from '../WorkerProtocol';

/**
 * Coordinator for single-client mode (e.g. Tauri / single-window).
 * Routes messages locally without SharedWorker.
 */
// NOTE: Both SharedWorkers and ServiceWorkers have severe limitations in WebViews:
// - SharedWorkers crash on iOS WKWebView (Apple Bug FB11723920).
// - ServiceWorkers require HTTP/HTTPS origins and cannot be used with custom URL schemes.
// TODO(wittjosiah): To support multiple windows on native platforms, implement coordinator in the Tauri Rust backend.
export class SingleClient implements WorkerProtocol.WorkerCoordinator {
  readonly onMessage = new Event<WorkerProtocol.CoordinatorMessage>();

  sendMessage(message: WorkerProtocol.CoordinatorMessage): void {
    // Echo messages back to self (single client, no cross-tab needed).
    queueMicrotask(() => this.onMessage.emit(message));
  }
}
